import { propertyMapping } from '@hakla/typed-forms'
import {
  AttachedResourceRequest,
  OfferRequest,
  OfferRequestPartner,
  OfferResponse,
} from '@/api/generated'

export function offerRequestResponseMapping() {
  return propertyMapping<OfferResponse, OfferRequest>(({ generic }) => {
    return {
      audiences: generic('audiences'),
      categories: generic('categories'),
      dateFrom: generic('dateFrom'),
      dateUntil: generic('dateUntil'),
      description: generic('description'),
      events: generic('events'),
      format: generic('format'),
      id: generic('id'),
      location: generic('location'),
      name: generic('name'),
      organisation: generic('organisation').deserializeWith(value => value.organisation?.id),

      partners: generic('partners').deserializeWith(value =>
        value.partners.map(partner => {
          return {
            date: partner.date,
            organisationId: partner.organisation.id,
          } as OfferRequestPartner
        })
      ),

      price: generic('price'),

      resources: generic('resources').deserializeWith(project => {
        const resources: AttachedResourceRequest[] =
          project.resources?.map(value => {
            return {
              name: value.name,
              resources: value.resources.filter(_ => _ !== undefined).map(resource => resource.id),
            }
          }) ?? []

        return resources
      }),

      sector: generic('sector'),
      shortDescription: generic('shortDescription'),
      subtitle: generic('subtitle'),
      title: generic('title'),
      type: generic('type'),
      visible: generic('visible'),
    }
  })
}
